package diana.soleil.design.iraniancanadienbazzar.feature.dashboard

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the owner dashboard. Aggregated by the app composition root (`:shared`). */
val dashboardModule = module {
    viewModel { DashboardViewModel(get(), get()) }
    viewModel { (businessId: String) -> ManageReviewsViewModel(get(), get(), businessId) }
    viewModel { (businessId: String) -> ListingAnalyticsViewModel(get(), get(), businessId) }
    viewModel { (businessId: String) -> EditListingViewModel(businessId, get(), get(), get()) }
}
